import { selectQuotationRoofBoxAccessories } from "app/containers/WorkOrder/redux/selector";
import { actions } from "app/containers/WorkOrder/redux/slice";
import {
  QuotationRoofBoxAccessoryCardKey,
  RoofBoxAccessoryCard,
} from "app/containers/WorkOrder/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { NOTE } from "../../../hooks/useQuoteBoxStructure";
import { QuoteSelectOption } from "../../../types";
import {
  FieldsRow,
  StructureCard,
} from "../OpenBoxQuotes/BoxStructureFields";
import { NoteField, NumberField, SelectField } from "../OpenBoxQuotes/FormFields";
import { roofKey } from "./BoxStructureCards";

export const useRoofBoxAccessories = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectQuotationRoofBoxAccessories);
  const patch = (
    key: QuotationRoofBoxAccessoryCardKey,
    value: Partial<RoofBoxAccessoryCard>
  ) => dispatch(actions.updateQuotationRoofBoxAccessories({ key, value }));

  return { data, patch };
};

type CardProps = {
  cardKey: QuotationRoofBoxAccessoryCardKey;
  titleKey: string;
};

export const AccessoryNoteCard = ({ cardKey, titleKey }: CardProps) => {
  const { data, patch } = useRoofBoxAccessories();
  const item = data[cardKey];

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={titleKey}
      onToggle={(enabled) => patch(cardKey, { enabled })}
    >
      <NoteField
        labelKey={NOTE}
        placeholderKey={NOTE}
        value={item.note}
        onChange={(note) => patch(cardKey, { note })}
      />
    </StructureCard>
  );
};

export const AccessoryQuantityCard = ({ cardKey, titleKey }: CardProps) => {
  const { data, patch } = useRoofBoxAccessories();
  const item = data[cardKey];

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={titleKey}
      onToggle={(enabled) => patch(cardKey, { enabled })}
    >
      <NumberField
        labelKey={roofKey("FIELDS.QUANTITY")}
        value={item.quantity}
        onChange={(quantity) => patch(cardKey, { quantity })}
      />
    </StructureCard>
  );
};

export const AccessoryTypeQuantityCard = ({
  cardKey,
  titleKey,
  options,
}: CardProps & { options: QuoteSelectOption[] }) => {
  const { data, patch } = useRoofBoxAccessories();
  const item = data[cardKey];

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={titleKey}
      onToggle={(enabled) => patch(cardKey, { enabled })}
    >
      <FieldsRow>
        <SelectField
          labelKey={roofKey("FIELDS.TYPE")}
          value={item.selectedOption}
          options={options}
          onChange={(selectedOption) => patch(cardKey, { selectedOption })}
          grow
        />
        <NumberField
          labelKey={roofKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch(cardKey, { quantity })}
          grow
        />
      </FieldsRow>
    </StructureCard>
  );
};
